import { atom } from "recoil";

export const isLoginAtom = atom({
  key: "isLoginAtom",
  default: false,
});
